import styled from 'styled-components';

export const Wrapper = styled.div`
    .heading {
        font-size: 2rem;
        text-align: center;
    }
    .score {
        text-align: center;
    }
    .qDiv {
        margin: 20px 0;
    }
    .qNum {
        text-align: center;
    }
    .qStatement {
        text-align: center;
        margin: 10px auto;
    }
`;
